import API_URL from '../../api/APIUrl'
import SubCasteRow from './SubCasteRow';
import { useState, useEffect } from 'react';
import { useSubCasteContext } from './useSubCasteContext';
import SideMenu from '../SideMenu';


const ManageSubCaste = () => {

    const {subcastes, dispatch} = useSubCasteContext();

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPending, setIsPending] = useState(true);
    const [error, setError] = useState(null);

   useEffect(()=>{

    const fetchSubCastes = async () => {
        const response = await fetch(API_URL.GET_ALL_SUBCASTE + "?p=" + currentIndex);
        const json = await response.json();

        if(response.ok){
          setIsPending(false);
          setError(null);
           dispatch({type:'SET_SUBCASTES',payload:json});
        }
        else{
          dispatch({type:'SET_SUBCASTES',payload:null});
          setIsPending(false);
          setError('No data found!');
        }
    }
      fetchSubCastes();
},[dispatch,currentIndex]);

   
    const handlePrevClick = () => {
        if (currentIndex > 0) {
          setCurrentIndex(currentIndex - 1);
        }
        else{
          alert("No further records");
        }
      };
      
      const handleNextClick = () => {
          if(subcastes){
            //console.log("Data Array: " + JSON.stringify(religions));
            setCurrentIndex(currentIndex + 1);
          }
          else{
             alert("No further records")
          }
      };

    return (
        <>
         <div className="d-flex">
        <SideMenu />


        <div id="page-content-wrapper" style={{ flex: 1, padding: '20px' }}>
        <div className="container-fluid">
        <h2>Manage SubCastes</h2>

        <div className="table-responsive">
        <table className="table table-striped table-hover">
            <thead>
                <tr key={1}>
                <th scope="col">#</th>
                <th scope="col">Title</th>
                <th scope="col">Caste</th>
                <th scope="col">Delete</th>
                </tr>
            </thead>
            <tbody>
            {error && <tr><td colSpan={4}>{error}</td></tr>}
            {isPending && <tr><td colSpan={4}>Loading....</td></tr>}
            { subcastes && subcastes.map((subcaste) => (
            
               <SubCasteRow
               key={subcaste._id}
               id={subcaste._id}
               title= {subcaste.title}
               caste = {subcaste.caste}
               />
                 ))
              }
           
            </tbody>
            </table>
            { (
                    <nav aria-label="Page navigation example">
                               
                    <ul className="pagination justify-content-center">
                        <li className="page-item"><button className="page-link" onClick={handlePrevClick}>Previous</button></li>
                        <li className="page-item"><button className="page-link" onClick={handleNextClick}>Next</button></li>
                    </ul>

                    </nav>)

            }
        </div>
       
            </div>
            </div>

        </div>
        </>
     
    )
}

export default ManageSubCaste;